import { Routes } from '@angular/router';
import { HomeComponent } from '@pages/home/home.component';
import { LoginComponent } from '@auth/login/login.component';
import { ChangePasswordComponent } from '@auth/change-password/change-password.component';
import { RegisterComponent } from '@auth/register/register.component';
import { ClassesComponent } from '@classes/classes-list/classes.component';
import { WelcomeComponent } from '@userOnboarding/welcome/welcome.component';
import { VideoComponent } from '@classes/class-video/video.component';
import { MessageSignupComponent } from '@userOnboarding/message-signup/message-signup.component';
import { QuizComponent } from '@classes/class-quiz/quiz.component';
import { ConfirmEmailComponent } from '@auth/confirm-email/confirm-email.component';
import { LearnMoreComponent } from '@pages/learn-more/learn-more.component';
import { ResetPasswordComponent } from '@auth/reset-password/reset-password.component';
import { LoginHelpComponent } from '@auth/login-help/login-help.component';
import { ContactUsComponent } from '@pages/contact-us/contact-us.component';
import { ContactUsSentComponent } from '@pages/contact-us-sent/contact-us-sent.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { LoginAuthGuard } from "@guards/LoginAuthGuard"
import { AdminAuthGuard } from "@guards/AdminAuthGuard"
import { AddToClassComponent } from '@admin/add-to-class/add-to-class.component';
import { AdminComponent } from '@admin/dashboard/pages/admin-panel/admin-panel.component';
import { AdminClassesComponent } from '@admin/dashboard/pages/admin-panel-classes/admin-panel-classes.component';
import { AdminUsersComponent } from '@admin/dashboard/pages/admin-panel-users/admin-panel-users.component';
import { AdminUserComponent } from '@admin/dashboard/pages/admin-panel-user/admin-panel-user.component';

import { ConstructionComponent } from '@pages/construction-page/construction.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';
import { AdminSettingsComponent } from '@admin/dashboard/pages/admin-settings/admin-settings.component';
//import { UserCreateComponent } from './users/user-create/user-create.component';
//import { UserListComponent } from './users/user-list/user-list.component';
//import { AuthGuard } from './guards/auth.guard';
//import { ChangePasswordComponent } from './change-password/change-password.component';
//import { ResetPasswordComponent } from './reset-password/reset-password.component';

export const appRoutes: Routes = [
  // Public Layout Routes (No authentication required)
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'home', component: HomeComponent },
      { path: 'login', component: LoginComponent },
      { path: 'login-help', component: LoginHelpComponent },
      { path: 'reset-password/:email/:token', component: ResetPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'contact-us', component: ContactUsComponent },
      { path: 'contact-us-sent', component: ContactUsSentComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'confirmemail/:email/:token', component: ConfirmEmailComponent },
      { path: 'confirmemail', component: ConfirmEmailComponent },
      { path: 'construction', component: ConstructionComponent },
      { path: 'learn-more', component: LearnMoreComponent },
      { path: 'message-signup', component: MessageSignupComponent },
    ]
  },
  
  // Private Layout Routes (Authentication required - User Dashboard)
  {
    path: 'app',
    component: PrivateLayoutComponent,
    canActivate: [LoginAuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'welcome', component: WelcomeComponent },
      { path: 'classes', component: ClassesComponent },
      { path: 'video/:id', component: VideoComponent },
      { path: 'quiz/:id', component: QuizComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'add-to-class', component: AddToClassComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  
  // Admin Layout Routes (Admin authentication required)
  {
    path: 'backoffice',
    component: PrivateLayoutComponent,
    canActivate: [AdminAuthGuard],
    data: { role: 'Admin' },
    children: [
      { path: 'dashboard', component: AdminComponent },
      { path: 'classes', component: AdminClassesComponent },
      { path: 'users', component: AdminUsersComponent },
      { path: 'user/:id', component: AdminUserComponent },
      { path: 'settings', component: AdminSettingsComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  
  // Legacy route redirects (for backward compatibility)
  { path: 'dashboard', redirectTo: '/app/dashboard', pathMatch: 'full' },
  { path: 'welcome', redirectTo: '/app/welcome', pathMatch: 'full' },
  { path: 'classes', redirectTo: '/app/classes', pathMatch: 'full' },
  { path: 'video/:id', redirectTo: '/app/video/:id', pathMatch: 'full' },
  { path: 'quiz/:id', redirectTo: '/app/quiz/:id', pathMatch: 'full' },
  { path: 'change-password', redirectTo: '/app/change-password', pathMatch: 'full' },
  { path: 'admin-dashboard', redirectTo: '/admin/dashboard', pathMatch: 'full' },
  { path: 'admin-classes', redirectTo: '/admin/classes', pathMatch: 'full' },
  { path: 'admin-users', redirectTo: '/admin/users', pathMatch: 'full' },
  { path: 'admin-user/:id', redirectTo: '/admin/user/:id', pathMatch: 'full' },
  
  // Wildcard route - must be last
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
